import { onMounted, onBeforeUnmount } from 'vue'
import { getStore } from '@/util/store'
import { getEnv } from '@/util/env'

export default function useSocket(bizType, bizId) {
  const WS_MAP = {
    dev: 'wss://devws.zhixuehuijiao.cn',
    test: 'wss://testws.zhixuehuijiao.cn',
    pre: 'wss://prews.zhixuehuijiao.cn',
    prod: 'wss://eduws.zhixuehuijiao.cn',
  }

  // 链接socket
  const socketConnect = () => {
    if (window.socket) return
    const token = getStore({ name: 'access_token' })
    // const host = 'ws://dev-eduws.zhixuehuijiao.cn' // 本地
    const host = WS_MAP[getEnv()]
    window.socket = new WebSocket(`${host}/websocket?token=${token}&bizType=${bizType}&bizId=${bizId}`)
    window.socket.onopen = () => {
      console.log('socket连接成功')
      socketHeart()
    }
    window.socket.onclose = () => {
      console.log('socket连接关闭')
      socketCloseHeart()
    }
    window.socket.onerror = () => {
      console.log('socket连接错误')
      socketClose()
      socketCloseHeart()
    }
  }

  // 断开socket
  const socketClose = () => {
    console.log('socket关闭')
    window.socket?.close()
    window.socket = null
  }

  // 心跳检测
  const socketHeart = () => {
    console.log('socket开始心跳检测')
    window.heartCheckInterval = setInterval(() => {
      socketSend({ msgType: 6, heart: 'ping' }, { transformJSON: true })
    }, 5000)
  }

  // 关闭心跳检测
  const socketCloseHeart = () => {
    console.log('socket关闭心跳检测')
    clearInterval(window.heartCheckInterval)
    window.heartCheckInterval = null
  }

  // 发送消息
  const socketSend = (data) => {
    if (window.socket && window.socket.readyState === WebSocket.OPEN) {
      console.log('socket发送信息', data)
      data && window.socket?.send(JSON.stringify(data))
    } else {
      console.error('socket未连接')
      socketClose()
      socketCloseHeart()
    }
  }

  // 接收消息
  const socketReceive = (callback) => {
    if (!window.socket) return
    window.socket.onmessage = (e) => {
      console.log('socket收到消息', JSON.parse(e.data))
      callback(JSON.parse(e.data))
    }
  }

  onMounted(() => {
    socketConnect()
  })

  onBeforeUnmount(() => {
    socketClose()
  })

  return {
    socketConnect,
    socketClose,
    socketSend,
    socketReceive,
  }
}
